import React from 'react'
import BigNumber from 'bignumber.js'
import Row from 'components/Layout/Row'
import tokens from 'config/constants/tokens'
import { useTranslation } from 'contexts/Localization'
import { usePriceVvsUsdc } from 'state/farms/hooks'
import { useVvsBoostPool } from 'state/xVvs/hooks'
import { BIG_ZERO } from 'utils/bigNumber'
import { getBalanceAmount } from 'utils/formatBalance'
import { useTooltip, Box, TooltipText } from 'vvs-uikit'
import LocalBalance from 'components/LocalBalance'
import useXvvsRate from '../../../hooks/useXvvsRate'
import { formatLockPeriod } from '../../../helpers'

interface LockPeriodTooltipProps {
  pid: number
  lockPeriod: number
}

const TooltipContent = ({ stakedAmount, tvl }: { stakedAmount: BigNumber; tvl: BigNumber }) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Row align="center">
        <Box width="110px">{t('Staked xVVS:')}</Box>
        <Box>
          {stakedAmount.toNumber().toLocaleString('en-US', {
            maximumFractionDigits: 6,
          })}
        </Box>
      </Row>
      <Row mt={1} align="center">
        <Box width="110px">{t('TVL:')}</Box>
        <LocalBalance fontSize="16px" decimals={6} value={tvl} color="white" />
      </Row>
    </Box>
  )
}

const LockPeriodText = ({ pid, lockPeriod }: LockPeriodTooltipProps) => {
  const rate = useXvvsRate()
  const price = usePriceVvsUsdc()
  const { boostPoolData } = useVvsBoostPool()
  const stakedAmount = boostPoolData.poolInfo.find((pool) => pool.poolId === pid)?.stakes || BIG_ZERO
  const formattedAmount = getBalanceAmount(stakedAmount, tokens.xvvs.decimals)
  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    <TooltipContent
      stakedAmount={formattedAmount}
      tvl={formattedAmount.times(rate ? rate.toSignificant(18) : BIG_ZERO).times(price)}
    />,
    { placement: 'bottom-start' },
  )

  return (
    <Box ml={3}>
      {tooltipVisible && tooltip}
      <TooltipText ref={targetRef} bold>
        {formatLockPeriod(lockPeriod)}
      </TooltipText>
    </Box>
  )
}

export default LockPeriodText
